export default __webpack_public_path__ + "static/media/coverEvent.bea49a7b.jpg";